module.exports = __webpack_public_path__ + "static/media/onboarding-welcome-stars.d1d17072.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onBoardingArrows/onboarding-welcome-stars.svg
// module id = 314
// module chunks = 21